import { cleartaxAxios, ctaAxios, mpBackendAxios } from '../../../http-common';
import { transformPricingPlans } from './pricing.transformer';
import { TPricingPlans } from './types';

export const PricingService = {
  getReviews: async function () {
    const data = await ctaAxios.get(`f/quick-service?key=ratings-reviews`);
    return data;
  },
  getPlanPricingAndDetails: async function (
    planIds: string[]
  ): Promise<TPricingPlans[]> {
    try {
      if (!planIds.length) return [];
      const res = await mpBackendAxios.get(
        `price/plans_pricing?plan_id=${planIds.join(',')}`
      );
      return transformPricingPlans(res.data);
    } catch (e) {
      return [];
    }
  },
  getQuestionaireAndPlanDetails: async function (
    choices: Record<string, boolean>
  ) {
    try {
      const res = await cleartaxAxios.post(
        `/External/GetPlansAsPerQuestionnaire`,
        choices
      );
      return res.data;
    } catch (e) {
      return {};
    }
  },
};
